var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":"grey lighten-4"}},[_c('v-container',[_c('v-row',{attrs:{"id":"header"}},[_c('v-col',{attrs:{"align":"center","justify":"center"}},[_c('p',{staticClass:"logo mb-1"},[_vm._v("Simon Little")]),_c('p',{staticClass:"subtitle mt-n5 grey--text mb-0"},[_vm._v("Full Stack Developer")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }